import axios from "axios";
import store from "@/store";
import { getToken } from "@/utils/auth";
import { Message } from "element-ui";

// 创建 axios 实例
const request = axios.create({
  // API 请求的默认前缀
  // window.abahzz.appconst.baseAPI
  baseURL: window.xindu.appconst.webApiUrl,

  timeout: 30000, // 请求超时时间
});
// 异常拦截处理器
const errorHandler = (errorRep) => {
  Message.closeAll();
  if (errorRep.response) {
    const { data, status } = errorRep.response;

    // 身份验证失败
    if (status === 401) {
      Message.error("登录过期，需要重新验证身份");
      // 如果登录了，则退出登录
      // if (token) {
      store.dispatch("user/logout").then(() => {
        setTimeout(() => {
          window.location.reload();
        }, 1500);
      });
      // }
      return;
    }

    // if (status === 403) {
    //   Message.error("权限不足");
    //   return Promise.reject(errorRep);
    // }

    // 账号密码错误
    if (status === 400 && errorRep.response.request.responseURL.includes("connect/token")) {
      Message.error("账号或密码错误，请重新输入！");
      return Promise.reject(errorRep);
    }
    if (data.error && data.error.message) {
      let mess = "";
      if (errorRep.response.config.url == "api/TokenAuth/Authenticate") {
        mess = data.error.message + data.error.details;
      } else if (
        ["ShareYearReport", "ShareMonthReport", "ShareDoubleMonthReport", "ShareBriefReport"].indexOf(
          errorRep.response.config.url.split("/Get?")[0].split("/api/services/app/")[1]
        ) != -1
      ) {
        mess = "数据源已不存在！无法进行查看";
      } else {
        mess = data.error.message;
      }
      Message.error(mess);
    } else {
      Message.error("请求出现未知错误！");
    }
    return Promise.reject(data);
  }
  return Promise.reject(errorRep);
};

// 请求前拦截
request.interceptors.request.use((config) => {
  const token = getToken();
  // 如果 token 存在
  // console.log(config);
  // 让每个请求携带自定义 token 请根据实际情况自行修改
  // config.headers["Content-Type"] = "application/x-www-form-urlencoded";
  if (token) {
    config.headers["Authorization"] = `Bearer ${token}`;
    if (config.url.includes("/exprot")) {
      config.timeout = 1000 * 60 * 5;
    }
  }

  return config;
}, errorHandler);

// 请求后拦截
request.interceptors.response.use((response) => {
  if (response.headers["content-disposition"] !== undefined) {
    // 附件类型响应,解析文件名称
    let dispositionHeader = response.headers["content-disposition"];
    let fileName =
      dispositionHeader.match(/(filename\*=UTF-8''(?<fileName>.+))/m)?.groups?.fileName ||
      dispositionHeader.match(/filename=(?<fileName>.+);/m)?.groups?.fileName ||
      dispositionHeader.match(/filename=(?<filename>.+)/m)?.groups?.filename ||
      new Date().getTime();
    response.headers["content-filename"] = decodeURI(fileName);
    let blob = new Blob([response.data], {
      type: response.headers["content-type"],
    });
    let url = window.URL.createObjectURL(blob);
    let a = document.createElement("a");
    a.href = url;
    a.download = response.headers["content-filename"];
    document.body.appendChild(a);
    a.click();
    // 5.释放这个临时的对象url
    window.URL.revokeObjectURL(url);
    document.body.removeChild(a);
    return response;
  }
  return response.data;
}, errorHandler);

export default request;
